module.exports = __webpack_public_path__ + "static/easiest-spring-e14b33529fd9d24838686ed1f60410ac.svg";